import React, { Component } from "react";
import logo from "../../assets/Images/vk-global-pub-logo@3x.png";
import {  NavLink } from "react-router-dom";
import "./NavBar.css";
import { connect } from "react-redux";
import { Navbar, Nav } from "react-bootstrap";
import * as actions from '../../Store/Actions/index'
class NavBar extends Component {
  state = {
    menus: [
      { name: "Home", path: "/", icon: "icon dripicons-home", key: 1 },
      {
        name: "About us",
        path: "/about",
        icon: " icon dripicons-user-group",
        key: 2
      },
      {
        name: "Catalogue",
        path: "/catalogue",
        icon: "icon dripicons-view-thumb",
        key: 3
      },
      {
        name: "Resources",
        path: "/resources",
        icon: "icon dripicons-box ",
        key: 4
      },
      {
        name: "Contact us",
        path: "/contact",
        icon: "icon dripicons-phone",
        key: 5
      }
    ],
    bookInputType: "allBooks",
  };

  closeNavbar = () => {
    var element = document.getElementById("toggle");

    var overlay = document.getElementById("overlay");
    element.classList.toggle("active");

    overlay.classList.remove("open");
  }

  toogleNvbarHnadler = () => {
    var element = document.getElementById("toggle");
    var overlay = document.getElementById("overlay");
    element.classList.toggle("active");
    overlay.classList.toggle("open");
  };

  doNothing = () => {
    return;
  }

  openCatalogue = () => {
    this.props.GetBookByInputType(this.state.bookInputType);
  }
  render() {
    return (
      <div className="container">
        <Navbar id="navigation" collapseOnSelect expand="xl">
          <Navbar.Brand>
            <img
              src={logo}
              width="160"
              height="59"
              className="d-inline-block align-top"
              alt = "logo"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto"></Nav>
            <Nav className="nav-links">
              {this.state.menus.map(menu => {
                return (
                  <NavLink
                  className="menuLinks"
                    exact={menu.name === "Home" ? true : false}
                    key={menu.key}
                    as={Nav.Link}
                    to={menu.path}
                    onClick = {menu.name === "Catalogue" ?  this.openCatalogue : this.doNothing}
                  >
                    <i className={` navBarLinks  ${menu.icon}`}></i> {menu.name}
                  </NavLink>
                );
              })}
              <NavLink className="menuLinks " as={Nav.Link} to="/cart">
                <i className="navBarLinks  icon dripicons-cart"></i> Cart
                {this.props.addedBook.length === 0 ? (
                  <span className="dot"></span>
                ) : (
                  <span className="green"></span>
                )}
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <div className="mobilenavbar">
          <div
            className="button_container"
            onClick={this.toogleNvbarHnadler}
            id="toggle"
          >
            <span className="top"></span>
            <span className="middle"></span>
            <span className="bottom"></span>
          </div>
          <div className="overlay" id="overlay">
            <nav className="overlay-menu">
              <ul onClick = {this.closeNavbar}>
                <li>
                  {/* <NavLink as = {Nav.Link} ></NavLink> */}
                  <NavLink exact to="/" as={Nav.Link} key="1">
                    <i className=" icon dripicons-home"></i> Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" key="2" as={Nav.Link}>
                    <i className=" icon dripicons-user-group"></i> About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/catalogue" as={Nav.Link} key="3">
                    <i className=" icon dripicons-view-thumb"></i> Catalogue
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/resources" as={Nav.Link} key="4">
                    <i className=" icon dripicons-box"></i> Resources
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact" as={Nav.Link} key="5">
                    <i className=" icon dripicons-phone"></i> Contact US
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
          <img src={logo} className="img-fluid" alt = "logo" />
          <NavLink
            to="/cart"
            className="float-right mobile-cart "
            as={Nav.Link}
          >
            <i style={{ display: "flex" }} className=" icon dripicons-cart">
              <h6 style={{ marginTop: "5px" }}>
                (
                {this.props.addedBook.length === 0
                  ? 0
                  : this.props.addedBook.length}
                )
              </h6>
              <div className="red"></div>
            </i>
          </NavLink>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addedBook: state.book.addedBooks
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetBookByInputType: (type) => dispatch(actions.GetBookByInputType(type)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
